import React from 'react';
import { styled } from '@mui/material/styles';
import { AccordionSummary } from '@mui/material';
import { ChevronRight } from '@piiqtechnologies/svg-icons';

const PeekAccordionSummary = styled((props) => (React.createElement(AccordionSummary, Object.assign({ expandIcon: React.createElement(ChevronRight, { fontStyle: "fontSize: 1rem" }) }, props))))(({ theme }) => ({
    flexDirection: "row-reverse",
    borderRadius: theme.spacing(0.8),
    "& .MuiAccordionSummary-expandIconWrapper": {
        color: theme.palette.primary.main,
        "&.Mui-expanded": {
            transform: "rotate(90deg)",
        },
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: theme.spacing(1),
    },
}));

export { PeekAccordionSummary, PeekAccordionSummary as default };
